import createSelector from 'selectorator';
import * as _ from 'lodash';

const getLicenses = createSelector(['licenses.licenses']);

export default {
  getLicenseList: createSelector([getLicenses], _.values),
  getStatus: createSelector(['licenses.status']),
};
